var _path, _path2, _rect, _rect2, _circle, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivateAccountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M0 0h45v45H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFAFF",
    d: "M-1085-388H835V692h-1920z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -371,
    y: -238,
    width: 493,
    height: 780,
    rx: 26.182,
    fill: "#ECF2FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -314,
    y: -23,
    width: 379,
    height: 92,
    rx: 12,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#ECF2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 6,
    width: 31,
    height: 31
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M7 6h31v31H7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 22.791c-1.421 0-2.637-.505-3.65-1.517-1.01-1.012-1.517-2.228-1.517-3.65v-4.52c0-.538.189-.995.566-1.372a1.865 1.865 0 0 1 1.372-.566c.323 0 .63.076.92.226.29.151.522.367.694.646.172-.28.404-.495.695-.646a1.977 1.977 0 0 1 1.84 0c.291.151.522.366.694.646.173-.28.404-.495.695-.646.29-.15.597-.226.92-.226.538 0 .995.19 1.372.566.377.377.566.834.566 1.372v4.52c0 1.422-.506 2.638-1.518 3.65s-2.228 1.517-3.65 1.517Zm0-2.583c.71 0 1.319-.253 1.825-.76a2.487 2.487 0 0 0 .758-1.823v-3.23h-5.166v3.23c0 .71.253 1.318.759 1.824s1.113.76 1.824.76ZM12.166 33.125v-3.617c0-.732.19-1.405.566-2.019a3.763 3.763 0 0 1 1.501-1.404 19.204 19.204 0 0 1 4.069-1.502c1.378-.333 2.777-.5 4.198-.5 1.42 0 2.82.167 4.198.5 1.378.334 2.734.835 4.069 1.502.624.323 1.124.791 1.5 1.404.378.614.566 1.287.566 2.02v3.616H12.167Zm2.584-2.584h15.5v-1.033c0-.237-.06-.452-.177-.646a1.262 1.262 0 0 0-.469-.452 16.865 16.865 0 0 0-3.52-1.308 15.004 15.004 0 0 0-7.168 0 16.863 16.863 0 0 0-3.52 1.308 1.252 1.252 0 0 0-.646 1.098v1.034Z",
    fill: "#006CC9"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -401,
    y: -265,
    width: 553,
    height: 840,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_124_557"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_124_557",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: -344,
    y: -50,
    width: 439,
    height: 152,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_124_557"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_124_557",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateAccountIcon);
export default __webpack_public_path__ + "static/media/private_account_icon.ba31a965c3522b8f0926081fcac9617b.svg";
export { ForwardRef as ReactComponent };